import type { InferRpcDefinition } from "@redotech/rpc/definition";

import { acceptKnowledgeSuggestion } from "./schema/accept-knowledge-suggestion";
import { createKnowledgeArticle } from "./schema/create-knowledge-article";
import { getDemoKnowledgeArticle } from "./schema/get-demo-knowledge-article";
import { getKnowledgeArticle } from "./schema/get-knowledge-article";
import { getKnowledgeItem } from "./schema/get-knowledge-item";
import { getKnowledgeSuggestions } from "./schema/get-knowledge-suggestions";
import { importKnowledgeCsv } from "./schema/import-knowledge-csv";
import { linkFaqKnowledge } from "./schema/link-faq-knowledge";
import { listKnowledge } from "./schema/list-knowledge";
import { rejectKnowledgeSuggestion } from "./schema/reject-knowledge-suggestion";
import { removeKnowledge } from "./schema/remove-knowledge";
import { scrapeKnowledge } from "./schema/scrape-knowledge";
import { setKnowledgeAvailability } from "./schema/set-knowledge-availability";
import { updateKnowledgeArticle } from "./schema/update-knowledge-article";
import { upsertDemoKnowledgeArticle } from "./schema/upsert-demo-knowledge-article";

export const rpcDefinition = {
  listKnowledge,
  getKnowledgeArticle,
  getKnowledgeItem,
  getKnowledgeSuggestions,
  createKnowledgeArticle,
  importKnowledgeCsv,
  updateKnowledgeArticle,
  setKnowledgeAvailability,
  removeKnowledge,
  linkFaqKnowledge,
  acceptKnowledgeSuggestion,
  rejectKnowledgeSuggestion,
  scrapeKnowledge,
  getDemoKnowledgeArticle,
  upsertDemoKnowledgeArticle,
};

export type RedoMerchantAgentKnowledgeRpcDefinition = InferRpcDefinition<
  typeof rpcDefinition
>;
